/**
 * AdminOrcaRepoRpcClient - AtomRpc integration for admin orca repo endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaRepoRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaRepoRpcClient extends AtomRpc.Tag<AdminOrcaRepoRpcClient>()(
  "AdminOrcaRepoRpcClient",
  {
    group: AdminOrcaRepoRpcs,
    protocol: makeRpcClientLayer(AdminOrcaRepoRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
